import { styled } from 'styled-components'

import { headerHeight } from 'constant'

export const Container = styled.div`
  > * {
    min-height: calc(100vh - ${headerHeight});
  }
`
